import React from 'react';
import { SUPPORT_EMAIL } from '../data/product';
export function Footer() {
  return <footer className="w-full bg-navy-deep" data-id="element-174" data-mp="3gezev8fo7z39">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-175" data-mp="3ggtx2ezk5d3n">
        <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-chalk" data-id="element-176" data-mp="32oni2w855c5s">
          Track <span className="text-hl" data-id="element-177" data-mp="36oo8lf8ildt7">Coach Ready</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-chalk/70" data-id="element-178" data-mp="36n3gdw9oa6yi">
          Every practice planned, for every event group.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-chalk/70" data-id="element-179" data-mp="38zawx2kd95j">
          <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex min-h-[44px] items-center px-1 hover:text-chalk hover:underline" data-id="element-180" data-mp="3ldamrdmenziu">
            {SUPPORT_EMAIL}
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-navy-line pt-5 text-xs leading-relaxed text-chalk/45" data-id="element-181" data-mp="29yxcxcohlklt">
          Track Coach Ready is a practice-planning resource for track and field
          coaches. It is not affiliated with or endorsed by any association,
          federation, league or school. It does not replace coaching
          certification, background checks, first-aid or CPR training, medical
          advice or an athletic trainer&apos;s evaluation. Throws, hurdles, high
          jump and pit jumps must always be supervised by a coach. Always follow
          your association&apos;s rules on heights, implements and event limits,
          and your school&apos;s or club&apos;s weather and safety policies. If an
          athlete has pain or an injury, stop the activity and refer them.
          Results depend on the coach and the team; no specific outcome is
          guaranteed. © Track Coach Ready 2026. All rights reserved.
        </p>
      </div>
    </footer>;
}